export default {
    view: "Voir plus"
}